import { render } from "./GroupsSearchForm.vue?vue&type=template&id=6fb56831"
import script from "./GroupsSearchForm.vue?vue&type=script&lang=js"
export * from "./GroupsSearchForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__